import { render, staticRenderFns } from "./LibramientoTermgGrid.vue?vue&type=template&id=a26b7f18&scoped=true&"
import script from "./LibramientoTermgGrid.vue?vue&type=script&lang=js&"
export * from "./LibramientoTermgGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26b7f18",
  null
  
)

/* custom blocks */
import block0 from "./LibramientoTermgGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports